import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useImprovePlaybookStep = () => {
  const {
    data: improvedPrompt,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<string>((response) => response);

  const improvePlaybookStep = async (
    playbookId: string,
    stepId: string,
    description?: string,
  ) => {
    return call(
      `/playbooks/${playbookId}/steps/${stepId}/improve`,
      "POST",
      undefined,
      {
        description,
      },
    );
  };
  return {
    improvedPrompt,
    improvePlaybookStep,
    isLoading,
    isFailed,
  };
};
